import { assertNotNull } from "common/assert";
import * as canplaythrough from "common/canplaythrough";
import { logError } from "common/error";
import { noop } from "common/functions";
import { showBlackScreen } from "common/htmlComponents/blackScreen";
import { load, smartVideo } from "common/loader";
import { cancel, delay, Waiter } from "common/promises";
import { ReesizeEventHandler } from "common/resize";
import { getSkip } from "common/skipper";
import { onVideoTime } from "common/video";
import { paths, smartVideo as smartVideoResource, video360Paths, video360SoundPath, } from "from-start/scene/resources";
import * as video360Sound from "from-start/scene/resources/video360Sound";
import * as FromStartSkipper from "from-start/skipper";
import log from "loglevel";
import { parse, unwrapEither } from "purs/VTT";
import * as R from "ramda";
import { Param } from "../interaction/common";
import { Video360LoadProgress } from "./videoLoadProgress";
import { VideoTailLooper } from "./videoTailLooper";
import { WatchVideoPlaying } from "./watchVideoPlaying";
export async function start(context, sound) {
    // await startTestbed();
    // return null as any;
    return await startReal(context, sound);
}
/**
 * 360 비디오 장면을 구현하는 함수
 * 비디오를 전부 다운받기 때문에 뒤에 내용을 테스트하기에는 불편하다.
 */
export async function startReal(context, loadingSound) {
    getSkip().skipDelay = false;
    const resizer = new ReesizeEventHandler();
    const { loadingSoundPromise, loadingSoundCanceler } = playLoadingSound(loadingSound);
    const video360Root = await createRoot();
    const { loaded, video360Sound_ } = await loadResource({
        context,
        video360Root,
    });
    video360Root.setAttribute("videoLoaded", "");
    const { startSoundPromise, startSoundCanceler } = playStartSound(video360Sound_);
    loadingSoundCanceler.cancel();
    video360Root.setAttribute("loadingFadeOut", "");
    await delay(1000);
    // tallLetterBoxIfPossible();
    const overlay = video360Root.querySelector("jh-360-video-overlay");
    resizer.add(overlay.onResize);
    log.debug("remove loading");
    video360Root.removeAttribute("loading");
    await delay(1000);
    video360Root.removeAttribute("fadeIn");
    await delay(2000);
    await getSkip().asyncRunSkippableOr(async () => {
        log.debug("show announce ");
        video360Root.setAttribute("announce", "");
        await video360Root.awaitAnnounceClick();
    }, async () => {
        const video = $("a-videosphere")[0].components
            .material.material.map.image;
        await video.play();
        const watcher = new WatchVideoPlaying(video);
        watcher.watch();
    });
    const video = $("a-videosphere")[0].components.material.material.map
        .image;
    const videoTailLooper = new VideoTailLooper({
        video,
        from: video.duration - 7 - 23 / 30,
        to: video.duration,
    });
    videoTailLooper.run();
    // loading sound가 끝났는지 꽤 뒤에서 체크
    // 혹시 기다리는데 시간이 오래걸리면 안되기 때문
    await loadingSoundPromise;
    startSoundCanceler.cancel();
    await startSoundPromise;
    context.interactionVideoLoader.loadStart();
    runSubtitleLoop(loaded["360video.vtt"].result, resizer).catch(console.error);
    await overlay.startFreeTime(video);
    log.debug("End free time");
    video360Root.setAttribute("progressElem", "");
    const progressElem = video360Root.querySelector("jh-360-video-progress");
    context.interactionVideoLoader.runWhenLoaded("1번 영상.mp4", async (element) => {
        log.debug("selfie video loaded", element);
        $(element).addClass("flip-card-back");
        element.id = "selfievideo";
        element.setAttribute("playsinline", "");
        element.setAttribute("webkit-playsinline", "");
        video360Root.querySelector(".flip-card-inner").appendChild(element);
    });
    progressElem.run({ index: 0, video });
    const waitSelfieButtonApear = new Waiter();
    onVideoTime({
        videoElement: video,
        timeMillis: video.duration * 1000 - 7000,
        callback: () => {
            video360Root.setAttribute("overlay", JSON.stringify({
                showBottomForVideo: true,
            }));
            video360Root.setAttribute("showSelfieIcon", "");
            video360Sound_.playLoop("pleaseClick");
            waitSelfieButtonApear.trigger();
        },
    });
    await waitSelfieButtonApear.wait();
    await context.interactionVideoLoader.wait("1번 영상.mp4");
    await video360Root.hasSelfieIconClicked.wait();
    video360Sound_.stopLoop("pleaseClick");
    overlay.showBottom = false;
    videoTailLooper.dispose();
    const ret = new Param();
    const selfievideo = $("#selfievideo")[0];
    onVideoTime({
        videoElement: selfievideo,
        timeMillis: (30 + 15 / 30) * 1000,
        callback: () => {
            overlay.hideTop();
        },
    });
    const videoElem = $("#selfievideo")[0];
    onVideoTime({
        videoElement: videoElem,
        callback: () => progressElem.fadeOutAndHide(),
        timeMillis: (videoElem.duration - 1) * 1000,
    });
    Promise.all([progressElem.run({ index: 1, video: selfievideo })])
        .then(async () => {
        showBlackScreen();
        // delay가 없으면 까만 화면 중간에 360비디오가 잠깐 보인다.
        // 1000 / 60 만 기다렸을 때는 안되었다. 기준은 무엇인가.
        await delay(100);
        videoElem.parentNode.removeChild(videoElem);
        progressElem.remove();
        video360Root.remove();
        ret.fill({ videoElem, progressElem });
    })
        .catch((err) => {
        logError(err);
    });
    // normalLetterBox();
    resizer.drop();
    return ret;
}
async function runSubtitleLoop(subtitleText, resizer) {
    log.warn("subtitle: ", subtitleText);
    const subtitleData = unwrapEither(parse(subtitleText)).right[0];
    log.warn("subtitle: ", subtitleData);
    const subtitle = document.querySelector("jh-360-video-subtitle");
    resizer.add(subtitle.onResize);
    const videoElement = $("#video-360");
    const waiter = new Waiter();
    const onTimeUpdate = () => {
        waiter.trigger();
    };
    videoElement.on("timeupdate", onTimeUpdate);
    let num = 0;
    let state = { name: "idle" };
    state = { name: "line", line: subtitleData.lines[num], show: false };
    // log.setLevel("trace");
    while (true) {
        await waiter.wait();
        waiter.reset();
        if (videoElement.prop("ended")) {
            state = { name: "finished" };
            break;
        }
        let current = subtitleData.lines[num];
        let currentTime = videoElement.prop("currentTime");
        if (getSkip().skipDelay) {
            currentTime = currentTime * 10;
        }
        if (current.toTime / 1000 < currentTime) {
            num += 1;
            if (num >= subtitleData.lines.length) {
                state = { name: "finished" };
                break;
            }
            state = { name: "line", line: subtitleData.lines[num], show: false };
            subtitle.setAttribute("text", "");
            log.trace("move to next line", state);
        }
        current = subtitleData.lines[num];
        if (current.fromTime / 1000 < currentTime) {
            if (state.show === false) {
                subtitle.setAttribute("text", subtitleData.lines[num].message);
                state.show = true;
                log.trace("Show current line", state);
            }
        }
    }
    subtitle.remove();
    videoElement.off("timeupdate", onTimeUpdate);
}
function playLoadingSound(sound) {
    const { promise, canceler } = cancel.root(async (canceler) => {
        log.debug("play loadingStart");
        await sound.awaitPlay("loadingStart");
        log.debug("end loadingStart");
        canceler.check();
        sound.playLoop("loadingLoop");
        await canceler.wait();
        sound.stopLoop("loadingLoop");
    });
    return {
        loadingSoundPromise: promise,
        loadingSoundCanceler: canceler,
    };
}
async function createRoot() {
    const video360Root = document.createElement("jh-360-video-root");
    video360Root.setAttribute("loading", "");
    video360Root.setAttribute("fadeIn", "");
    document.querySelector("#resizer").appendChild(video360Root);
    await video360Root.hasRendered.wait();
    return video360Root;
}
/**
 * 로드한 리소스를 반환한다.
 */
async function loadResource({ context, video360Root, }) {
    if (context.config.loadVideo360 === "xhr") {
        return loadResourcePreload({ video360Root });
    }
    else {
        return loadResourceHTMLVideo({ video360Root });
    }
}
async function loadResourceHTMLVideo({ video360Root, }) {
    const aframeLoadWaiter = new Waiter();
    const audioLoadWaiter = new Waiter();
    const smartProgress = new Video360LoadProgress();
    let audioSrc = "";
    log.debug("Load 360video files haha");
    const defaultFileLoadArgs = smartVideoResource.video360FileLoadArgs;
    const override = {
        video360TheVideo: {
            onProgress: (progress) => {
                progress = smartProgress.overrideProgress(progress);
                video360Root
                    .loadingElement()
                    .setAttribute("progress", `${progress * 100}`);
            },
            videoTagPrepare: () => {
                const element = $(`<video class="dn" id="video-360">
          playsinline
          webkit-playsinline
          crossorigin="anonymous"
        </video>`);
                element.appendTo(video360Root);
                element[0].crossOrigin = "anonymous";
                element[0].load();
                return element[0];
            },
            onXHRFinished: (ev) => {
                const element = ev.result;
                assertNotNull(element, "element");
                log.debug("360 video append to 360 root");
                $(element).addClass("dn");
                element.id = "video-360";
                element.setAttribute("playsinline", "");
                element.setAttribute("webkit-playsinline", "");
                element.setAttribute("crossorigin", "anonymous");
                element.load();
                video360Root.appendChild(element);
            },
            method: "videoTag",
        },
        video360AframeSrc: {
            onComplete: () => {
                aframeLoadWaiter.trigger();
            },
        },
    };
    const fileLoadArgs = R.mergeDeepRight(defaultFileLoadArgs, override);
    const audioLoadArgs = {
        name: "normal",
        type: "sound",
        path: video360SoundPath,
        onProgress: noop,
        onComplete: (ev) => {
            const src = ev.result.src;
            assertNotNull(src, "src");
            audioSrc = src;
            audioLoadWaiter.trigger();
        },
    };
    const loadAll = smartVideo.load({
        files: [...R.values(fileLoadArgs), audioLoadArgs],
    });
    await aframeLoadWaiter.wait();
    video360Root.setAttribute("preloadAframe", "");
    await audioLoadWaiter.wait();
    const video360Sound_ = await video360Sound.loadSound(audioSrc);
    const loaded = await loadAll;
    await smartProgress.makeFull((progress) => {
        video360Root.loadingElement().setAttribute("progress", `${progress * 100}`);
    });
    log.trace("loaded", loaded);
    return { loaded, video360Sound_ };
}
async function loadResourcePreload({ video360Root, }) {
    const aframeLoadWaiter = new Waiter();
    const audioLoadWaiter = new Waiter();
    let audioSrc = "";
    log.debug("Load 360video files");
    const loadAll = load({
        onFileProgress: ({ id, progress }) => {
            if (id === "360video") {
                video360Root
                    .loadingElement()
                    .setAttribute("progress", `${progress * 100}`);
            }
        },
        onFileload: (e) => {
            log.debug("onFileload", e.item.id);
            if (e.item.id === "aframeSrc") {
                log.warn("onFileload aframe", e);
                aframeLoadWaiter.trigger();
            }
        },
        onAudio: (src) => {
            audioSrc = src;
            audioLoadWaiter.trigger();
        },
        onVideo: ({ element, id }) => {
            log.debug(element, id);
            if (id === "360video") {
                log.debug("360 video append to 360 root");
                $(element).addClass("dn");
                element.id = "video-360";
                element.setAttribute("playsinline", "");
                element.setAttribute("webkit-playsinline", "");
                video360Root.appendChild(element);
            }
            else {
                throw new Error("unreachable");
            }
        },
        filePaths: [...video360Paths, video360SoundPath],
    });
    await aframeLoadWaiter.wait();
    video360Root.setAttribute("preloadAframe", "");
    await audioLoadWaiter.wait();
    const video360Sound_ = await video360Sound.loadSound(audioSrc);
    const loaded = await loadAll;
    log.trace("loaded", loaded);
    await Promise.race([
        canplaythrough.wait(document.querySelector("#video-360")),
        delay(5000),
    ]);
    return { loaded, video360Sound_ };
}
function playStartSound(video360Sound_) {
    video360Sound_.play("arrivalEffect1");
    const { promise, canceler } = cancel.root(async (canceler) => {
        const playingId = {
            id: null,
        };
        canceler.wait().then(() => {
            if (playingId.id != null) {
                video360Sound_.stop(playingId.id);
            }
        });
        playingId.id = video360Sound_.play("arrivalEffect2");
        while (true) {
            await delay((2 + 25 / 30) * 1000);
            canceler.check();
            playingId.id = video360Sound_.play("arrivalEffect2");
        }
    });
    return {
        startSoundPromise: promise,
        startSoundCanceler: canceler,
    };
}
/**
 * 360 video의 엘리먼트들을 쉽게 테스트할 수 있게 환경을 구축하는 함수
 * 대표적으로 비디오를 다운로드하는 대신에 스트리밍한다.
 */
export async function startTestbed() {
    await load({
        filePaths: [paths.video360AframeSrc],
    });
    const video360Root = document.createElement("jh-360-video-root");
    document.querySelector("#resizer").appendChild(video360Root);
    video360Root.setAttribute("fadeIn", "");
    video360Root.removeAttribute("fadeIn");
    await delay(1);
    const videoElement = $(`<video id="video-360" src="${paths.video360TheVideo}" class="dn"/>`);
    const canPlayWaiter = new Waiter();
    videoElement.one("canplay", () => {
        canPlayWaiter.trigger();
    });
    $(video360Root).append(videoElement);
    await Promise.race([canPlayWaiter.wait(), delay(1000)]);
    video360Root.setAttribute("videoLoaded", "");
    log.debug("show announce ");
    // video360Root.setAttribute("announce", "");
    // await video360Root.awaitAnnounceClick();
    video360Root.setAttribute("progressElem", "");
    let progress = 0;
    const progressElem = video360Root.querySelector("jh-360-video-progress");
    while (true) {
        progress += 1;
        if (progress > 100) {
            progress = 0;
        }
        await delay(100);
        progressElem.setAttribute("progress", JSON.stringify({
            short: [progress, progress, progress, progress, progress, progress],
            long: [progress, progress],
        }));
    }
}
export async function skippedStart(context, waitVideo) {
    if (FromStartSkipper.getSkip().interactionVideo.first === "short") {
        return shortSkip(context);
    }
    if (FromStartSkipper.getSkip().interactionVideo.first === "skip") {
        return fullSkip(context, waitVideo);
    }
    return fullSkip(context, waitVideo);
}
async function fullSkip(context, waitVideo) {
    log.info("360 skipped start");
    context.interactionVideoLoader.loadStart();
    const ret = new Param();
    context.interactionVideoLoader.runWhenLoaded("1번 영상.mp4", async (element) => {
        log.debug("selfie video loaded", element);
        element.id = "selfievideo";
        element.setAttribute("playsinline", "");
        element.setAttribute("webkit-playsinline", "");
        $("#resizer").append(element);
        log.info("wait for click to play 360 skipped video");
        $(document).one("click", async () => {
            log.info("play skipped 360 video");
            element.play().catch(logError);
            const progressElem = document.createElement("jh-360-video-progress");
            $("#resizer").append(progressElem);
            progressElem.run({ index: 1, video: element });
            if (waitVideo) {
                await delay(1000);
                element.currentTime = element.duration - 4;
                onVideoTime({
                    videoElement: element,
                    timeMillis: (element.duration - 1) * 1000,
                    callback: () => {
                        progressElem.fadeOutAndHide();
                    },
                });
                $(element).one("ended", () => {
                    ret.fill({ videoElem: element, progressElem });
                });
            }
            else {
                ret.fill({
                    videoElem: element,
                    progressElem,
                });
            }
        });
    });
    await context.interactionVideoLoader.wait("1번 영상.mp4");
    return ret;
}
async function shortSkip(context) {
    log.info("360 skipped start");
    context.interactionVideoLoader.loadStart();
    const ret = new Param();
    context.interactionVideoLoader.runWhenLoaded("1번 영상.mp4", async (element) => {
        log.debug("selfie video loaded", element);
        element.id = "selfievideo";
        element.setAttribute("playsinline", "");
        element.setAttribute("webkit-playsinline", "");
        $("#resizer").append(element);
        const progressElem = document.createElement("jh-360-video-progress");
        $("#resizer").append(progressElem);
        log.info("wait for click to play 360 skipped video");
        $(document).one("click", () => {
            log.info("play skipped 360 video");
            element.play().catch(logError);
            progressElem.run({ index: 1, seconds: element.duration });
        });
        onVideoTime({
            videoElement: element,
            timeMillis: (element.duration - 1) * 1000,
            callback: () => {
                progressElem.fadeOutAndHide();
            },
        });
        $(element).one("ended", () => {
            log.debug("1번 영상.mp4 ended");
            progressElem.remove();
            ret.fill({
                videoElem: element,
                progressElem,
            });
        });
    });
    await context.interactionVideoLoader.wait("1번 영상.mp4");
    return ret;
}
//# sourceMappingURL=main.js.map